import { Component } from 'react';
import {connect} from 'react-redux';
import {Control, Errors} from 'forms/rrf';
import {Col, Container, FormGroup, FormLabel, Row} from 'react-bootstrap';
import BsCheckbox from '../../../common/form/elements/bs-checkbox';

import Editor from './editor';
import './styles.css';

class EmailMessage extends Component {
  state = {
    email: false,
  };

  setEmail = () => {
    this.setState({
      email: !this.state.email
    });
  };

  render() {
    return (
      <Container fluid className="editor">
        <Row>
          <Col md={12}>
            <FormGroup>
              <Control.checkbox
                component={BsCheckbox}
                model='.email'
                onChange={this.setEmail}
              >
                Email
              </Control.checkbox>
            </FormGroup>
            <FormGroup>
              <FormLabel>
                Subject*
              </FormLabel>
              <Control.text
                className="form-control"
                model=".email_subject"
              />
              <Errors
                className="errors"
                model=".email_subject"
                show={{
                  touched: true,
                  focus: false
                }}
              />
            </FormGroup>

            {this.props.fetched && (
              <Editor
                content={this.props.emailBody}
                field="deep.admin_notification_edit.email_body"
              />
            )}

          </Col>
        </Row>
      </Container>

    );
  }
}

const mapStateToProps = state => ({
  emailBody: state.deep.admin_notification_edit.email_body,
  fetched: state.notifications.fetched,
  fetching: state.notifications.fetching,
});

export default connect(mapStateToProps)(EmailMessage);
